import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import config       from '@/config';
import useStateHandler from '@/hooks/useStateHandler';
import fetchWrapper from '@/services/fetchWrapper.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import ArtistsAdminCard from '@/shared-components/cards/components/ArtistsAdminCard';
import { canAccessGalleryPermission } from '@/utils/galleryPermissions';

import './artist-mgmt-card.css';

export default function ArtistMgmtCard({ artistData }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { state } = useStateHandler();
  const session = state?.user_session;
  const galleryId = session?.gallery_id || session?._id;
  const canViewArtistDetails = canAccessGalleryPermission(session, 'artists.view_details', galleryId);

  const handleViewMore = async (e) => {
    e.stopPropagation();
    if (!canViewArtistDetails) return;
    setLoading(true);
    try {
      // 1) comprobar si ya existe
      const getRes = await fetchWrapper.get(
        `${config.apis.api.url}/permissions?artist=${artistData._id}&gallery_id=${encodeURIComponent(galleryId || '')}`,
        { injectToken: true }
      );
      if (!getRes.response.ok) throw new Error("GET /permissions failed");

      const permission = getRes.data[0] || null;

      // 3) navegar con los datos
      navigate(`/my-artists/${artistData._id}`, {
        state: { artist: artistData, permissions: permission }
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="artist-mgmt-card__container" onClick={handleViewMore}>
      <ArtistsAdminCard artistData={artistData}>
        <ContinueButton
          className="artist-admin-card__view-more-btn"
          onClick={handleViewMore}
          loading={loading}
        >
          View more
        </ContinueButton>
      </ArtistsAdminCard>
    </div>
  );
}
